@file:Suppress("ClassName")

package org.ssoft.common.type

sealed class DashboardCategory(override val mask: Int) : Mask {
    /** 2 */
    data object UNDEFINED : DashboardCategory(2)
    /** 4 */
    data object COMPANY : DashboardCategory(4)
    /** 8 */
    data object LOCATION : DashboardCategory(8)
    /** 16 */
    data object CAMPAIGN : DashboardCategory(16)
    /** 32 */
    data object DEVICE : DashboardCategory(32)

    companion object {
        val all by lazy {
            listOf(
                UNDEFINED,
                COMPANY,
                LOCATION,
                CAMPAIGN,
                DEVICE,
            )
        }

        operator fun get(mask: Int): DashboardCategory = Mask[mask, all] ?: UNDEFINED

    }
}